import { Aboutus } from "../components/home/Aboutus/aboutus";
import { Footer } from "../components/footer/footer";
import Header from "../components/home/header/header";
import { Quote } from "../components/home/quote/quote";
import { Diseases } from "../components/home/diseases/diseases";
import { Blogs } from "../components/home/blogs";
import { Doctors } from "../components/home/doctors/doctors";
import { ContactUS } from "../components/home/contact-us/contact-us";
import { diseases } from "../data/diseases";

//style
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

export const Home = ({ setViewDiagnosis }) => {
  return (
    <div className="home">
      <Header setViewDiagnosis={setViewDiagnosis} />
      <Aboutus />
      <Quote />
      <Diseases items={diseases} />
      <Blogs items={diseases} />
      <Doctors />
      <ContactUS />
      <Footer />
    </div>
  );
};
